<template>
    <div class="incident-risk-types-page">
        <app-sub-title text="Tipos de Incidentes y Riesgos" />
        <div class="incident-risk-types-page-buttons">
            <button class="btn btn-primary" @click="openForm">
                <i class="fa fa-plus"></i> Crear Tipo
            </button>
        </div>
        <app-incident-risk-types-filters
            :onFilter="onFilter"
            :onClearFilters="onClearFilters"
        />
        <app-incident-risk-types-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="onDelete"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="incident-risk-type-form"
            :title="!type ? 'Crear Tipo' : 'Editar Tipo'"
            :on-close="() => $bus.$emit('incident-risk-type-form.clear')"
        >
            <div slot="body">
                <app-incident-risk-type-form
                    :selected-type="type"
                    :on-save="onSave"
                    id="incident-risk-type-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="inProgress"
                    @click="saveType"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            id="incident-risk-type-delete-confirm"
            title="Confirmar Eliminación"
            :on-close="closeDeleteModal"
        >
            <div slot="body">
                <p class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Esta acción no se puede deshacer.
                </p>
                <p>
                    ¿Está seguro de eliminar el tipo
                    <strong>"{{ typeToDelete ? typeToDelete.name : '' }}"</strong>?
                </p>
            </div>
            <div slot="buttons">
                <button class="btn btn-danger" @click="confirmDelete" :disabled="deleting">
                    <i class="fa fa-trash"></i> Eliminar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import incidentRiskTypesRepository from "../../../repositories/incident-risk-types.repository";
import SubTitle from "../../UI/Layout/SubTitle.vue";
import IncidentRiskTypesList from "./IncidentRiskTypesList.vue";
import IncidentRiskTypesFilters from "./IncidentRiskTypesFilters.vue";
import IncidentRiskTypeForm from "./IncidentRiskTypeForm.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        appSubTitle: SubTitle,
        appIncidentRiskTypesList: IncidentRiskTypesList,
        appIncidentRiskTypesFilters: IncidentRiskTypesFilters,
        appIncidentRiskTypeForm: IncidentRiskTypeForm
    },
    data() {
        return {
            data: {},
            page: 1,
            filters: {},
            type: null,
            typeToDelete: null,
            deleting: false,
            sort: {
                sortBy: "name",
                sortDir: "asc"
            }
        };
    },
    computed: {
        ...mapGetters(["client", "user"])
    },
    methods: {
        async loadTypes() {
            try {
                const filters = {
                    ...this.filters,
                    page: this.page
                };
                const { data } = await incidentRiskTypesRepository.get(filters);
                this.data = data;
            } catch (error) {
                toastr.error("Ocurrió un error al cargar los tipos");
            }
        },
        onChangePage(page) {
            this.page = page;
            this.loadTypes();
        },
        onEdit(type) {
            this.type = type;
            this.openForm();
        },
        onDelete(type) {
            this.typeToDelete = type;
            this.openDeleteModal();
        },
        openDeleteModal() {
            this.$bus.$emit("incident-risk-type-delete-confirm.open");
        },
        closeDeleteModal() {
            this.$bus.$emit("incident-risk-type-delete-confirm.close");
            this.typeToDelete = null;
            this.deleting = false;
        },
        async confirmDelete() {
            if (!this.typeToDelete) {
                return;
            }

            this.deleting = true;
            try {
                const { data } = await incidentRiskTypesRepository.delete(this.typeToDelete.id);
                if (data.status) {
                    this.closeDeleteModal();
                    this.loadTypes();
                    toastr.success(data.msg || "El tipo ha sido eliminado");
                } else {
                    toastr.error(data.msg || "Error al eliminar el tipo");
                }
            } catch (error) {
                toastr.error("Ocurrió un error al eliminar el tipo");
            } finally {
                this.deleting = false;
            }
        },
        onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadTypes();
        },
        onClearFilters() {
            this.page = 1;
            this.filters = {};
            this.loadTypes();
        },
        saveType() {
            this.$bus.$emit("incident-risk-type-form.save");
        },
        onSave() {
            this.closeForm();
            this.loadTypes();
        },
        openForm() {
            this.$bus.$emit("incident-risk-type-form.open");
        },
        closeForm() {
            this.$bus.$emit("incident-risk-type-form.close");
            this.type = null;
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadTypes();
        }
    },
    created() {
        if (!this.user || this.user.profile.slug !== 'cliente-admin') {
            this.$router.push({ name: 'admin' });
            return;
        }
        this.loadTypes();
    }
};
</script>

